<script>
  import { layoutMethods, digitalLoadMethods } from "@/state/helpers";
  import { required } from "vuelidate/lib/validators";
  import Swal from 'sweetalert2';
  import { getModuleAccess } from '@/router/helper.js';
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";

  /**
   * E-Load Provider Form component
   */
  export default {
    page: {
      title: "E-Load Provider Form"
    },
    components: {
      flatPickr,
    },
    computed: {
    },
    data() {
      return {
        title: "E-Load Provider Form",
        provider_id: 0,
        form:{
          status          : true,
          provider_name   : null,
          api_endpoint    : null,
          front_margin    : null,
          back_margin     : null,
          total_margin    : null,
          sku_level       : false,
        },
        formExitChecker:{
          status          : true,
          provider_name   : null,
          api_endpoint    : null,
          front_margin    : null,
          back_margin     : null,
          total_margin    : null,
          sku_level       : false,
        },
        submitted : false,
        eloadProviderModule: {
          access: {
            create: false,
            read: false,
            update: false,
            delete: false
          }
        },
        changeLogModal:false,
        providerLogs: [],
        providerLogsTotal: 0,
        logFields: [
          {key: 'actor',label:'Modified By',sortable: true},
          {key: 'margin_type',label:'Type of Margin Rebate',sortable: false},
          {key: 'old_value',label:'Previous Margin Rebate',sortable: false},
          {key: 'new_value',label:'New Margin Rebate',sortable: false},
          {key: 'created_at',label:'Date & Time Modified',sortable: true},
        ],
        searchValue: {
          dateRange: null,
          margin_type: null,
          sort: 'id',
          orderDesc: true,
          page: 1,
          rows: 10
        },
        rangeOptions: {
          mode: "range",
        },
        marginTypeOption:[{"value": null,"text":"All"},{"value": 'fm',"text":"Front Margin"},{"value": 'bm',"text":"Back Margin"}],
        sortBy: "id",
        sortDesc: true,
      };
    },
    validations: {
      form: {
        status              : {required},
        provider_name       : {required},
        api_endpoint        : {required},
        front_margin        : {},
        back_margin         : {},
        total_margin        : {}
      },
    },
    methods: {
      ...layoutMethods,
      ...digitalLoadMethods,
      cancelRouting(){
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "E-Load Provider"
            }
          );
      },
      async handleSubmit(){
        this.submitted = true
        this.$v.$touch();
        if (!this.$v.form.$invalid){
            console.log(":: FORM ::", JSON.stringify(this.form));
            await this.actionProvider({
                action: (this.provider_id > 0 ? "update":"create"),
                body: this.provider_id > 0 ? {...this.form,"provider_id":this.provider_id}:this.form
            })
            .then((res) => {
              console.log(res);
              Swal.fire(
                (this.provider_id > 0 ?"Updated":"Created")+" Successful!",
                res["message"],
                "success"
              );
              this.formExitChecker = {...this.form}
              this.cancelRouting();
            }).catch((e)=>{
              console.log("error while creating a job",e);
              Swal.fire(
                (this.provider_id > 0 ?"Update":"Create")+" Failed!",
                e["message"],
                "error"
              );
            });
        }
      },
      async getInformation(){
        await this.actionProvider({
            action: "info",
            body: {"provider_id":this.provider_id}
        })
        .then((res) => {
          this.form                       = {...res["message"]}
          this.formExitChecker            = {...res["message"]}
        }).catch((e)=>{
          console.log("error while getting details",e);
        });
      },
      leaveform(next){
          if(JSON.stringify(this.form) == JSON.stringify(this.formExitChecker)){
            next();
            return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  next();
              }else{
                  return;
              }
          })
      },
      totalMarginComputation(){
        var fr = 0,
            br =0;
        if(!isNaN(parseFloat(this.form.front_margin))){
          fr = parseFloat(this.form.front_margin)
        }
        if(!isNaN(parseFloat(this.form.back_margin))){
          br = parseFloat(this.form.back_margin)
        }
        this.form.total_margin = fr + br
        if(this.form.total_margin < 0){
          this.form.total_margin = 0
        }
      },
      viewChangeLogModal(){
        this.changeLogModal = true;
        this.getProviderLogs();
      },
      async getProviderLogs(state=''){
        if(state == 'reset'){
          this.searchValue.page = 1;
        }
        await this.actionProvider({
            action: "provider-logs",
            body: {...this.searchValue,provider_id:this.provider_id}
        })
        .then((res) => {
          this.providerLogsTotal = res["message"]["pageInfo"]["total"];
          this.providerLogs = res["message"]["rows"];
        }).catch((e)=>{
          console.log("error while getting details",e);
        });
      },
      tableSorting(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        this.getProviderLogs('reset');
      },
      onSkuLevelStatus(){
        if(this.form.sku_level == false){
          this.form.back_margin = 0;
          this.totalMarginComputation();
        }
      }
    },
    async mounted(){
      this.provider_id = this.$route.params.id;
      this.changeTitle({title: (this.provider_id == 0 ? "Add":"Edit") + ' E-Load Provider'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'E-Load Provider', to: { name: 'E-Load Provider'} },
          { text: 'E-Load Provider Form', to: { name: 'E-Load Provider Form'} }
        ]
      });
      if(this.provider_id > 0){
        // alert("hey eedited");
        this.getInformation();
      }

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'eLoad', 'eLoad Provider')
        .then((access) => this.eloadProviderModule.access = access);
    },
    beforeRouteLeave(to, from, next) {
        if(JSON.stringify(this.form) != JSON.stringify(this.formExitChecker)){
          this.leaveform(next);
        }else{
          next();
        }
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-8">
            <!-- offset-md-3 -->
            <div class="card">
                <div class="card-body">
                  
                  <form class="px-4" @submit.prevent="handleSubmit()">
                    <div class="row">
                      <label v-if="(provider_id <= 0 || isNaN(provider_id)) && !eloadProviderModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a provider.</label>
                      <label v-else-if="provider_id > 0 && !eloadProviderModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a provider.</label>
                      <div class="col-md-12 mb-3"><!--start active status-->
                        <div class="form-check form-switch">
                          <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                          <input
                            class="form-check-input"
                            v-model="form.status"
                            type="checkbox"
                            id="flexSwitchCheckDefault"
                          />
                        </div>
                      </div><!--end active status-->
                      <div class="mb-3 col-md-12"><!--Provider Name-->
                        <label class="form-label small fw-bold">Provider Name<span style="color: red">*</span></label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="form.provider_name"
                          placeholder="Enter Provider Name"
                          :class="{
                              'is-invalid': submitted && $v.form.provider_name.$error,
                          }"
                        />
                        <div v-if="submitted && $v.form.provider_name.$error"
                          class="text-danger">
                          <span v-if="!$v.form.provider_name.required">This value is required.</span>
                        </div>
                      </div><!--Provider Name-->
                      <div class="border-bottom pb-3 mb-2 col-md-12"><!--API Endpoint-->
                        <label class="form-label small fw-bold">API Endpoint<span style="color: red">*</span></label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="form.api_endpoint"
                          placeholder="Enter API Endpoint"
                          :class="{
                              'is-invalid': submitted && $v.form.api_endpoint.$error,
                          }"
                        />
                        <div v-if="submitted && $v.form.api_endpoint.$error"
                          class="text-danger">
                          <span v-if="!$v.form.api_endpoint.required">This value is required.</span>
                        </div>
                      </div><!--API Endpoint-->

                    <div class="col-md-12 mb-3"><!--start sku level-->
                      <div class="form-check form-switch">
                        <label class="form-check-label" for="flexSwitchCheckDefault">SKU Level</label>
                        <input
                          class="form-check-input"
                          v-model="form.sku_level"
                          @click="onSkuLevelStatus()"
                          type="checkbox"
                          id="flexSwitchCheckDefault"
                        />
                      </div>
                    </div><!--end sku level-->

                    <div class="mb-3 col-sm-6 p-r-0">
                      <label class="form-label">Front Margin Rebate %</label>
                      <b-input-group>
                        <b-form-input
                          type="number"
                          class="form-control"
                          v-model="form.front_margin"
                          placeholder="0"
                          v-on:keyup="totalMarginComputation()"
                          :class="{
                              'is-invalid': submitted && $v.form.front_margin.$error,
                          }"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            variant="light"
                            type="button"
                            class="rounded-0 rounded-end px-2" 
                            style="border: 1px #ccc solid;"
                          >
                          %
                          </b-button>
                        </b-input-group-append>
                        <div>
                          <i class="uil uil-plus text-secondary bp-icon-center"></i>
                        </div>
                      </b-input-group>
                      <div v-if="submitted && $v.form.front_margin.$error"
                        class="text-danger">
                        <span v-if="!$v.form.front_margin.required">This value is required.</span>
                      </div>
                    </div>
                    <div class="mb-3 col-sm-6 p-r-0">
                      <label class="form-label">Back Margin Rebate %</label>
                      <b-input-group>
                        <b-form-input
                          type="number"
                          class="form-control"
                          v-model="form.back_margin"
                          placeholder="0"
                          v-on:keyup="totalMarginComputation()"
                          :class="{
                              'is-invalid': submitted && $v.form.back_margin.$error,
                          }"
                          :disabled = "form.sku_level"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            variant="light"
                            type="button"
                            class="rounded-0 rounded-end px-2" 
                            style="border: 1px #ccc solid;"
                          >
                          %
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <div v-if="submitted && $v.form.back_margin.$error"
                        class="text-danger">
                        <span v-if="!$v.form.back_margin.required">This value is required.</span>
                      </div>
                    </div>
                    <div class="mb-3 col-sm-12 p-r-0">
                      <label class="form-label">Total Margin Rebate %</label>
                      <b-input-group>
                        <b-form-input
                          type="number"
                          class="form-control"
                          v-model="form.total_margin"
                          placeholder="0"
                          :disabled="true"
                          :class="{
                              'is-invalid': submitted && $v.form.front_margin.$error,
                          }"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            variant="light"
                            type="button"
                            class="rounded-0 rounded-end px-2" 
                            style="border: 1px #ccc solid;"
                          >
                          %
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <div v-if="submitted && $v.form.front_margin.$error"
                        class="text-danger">
                        <span v-if="!$v.form.front_margin.required">This value is required.</span>
                      </div>
                      <div class="text-muted fs-10">
                        Notes: 
                        <span v-if="!form.sku_level">Front Margin Rebate + Back Margin Rebate = Total Margin Rebate</span>
                        <span v-if="form.sku_level">Back margin will automatically be at 0% rebate due to dependency with SKU Level.</span>
                      </div>
                    </div>
                    </div><!--end of row-->

                    <p v-if="provider_id > 0"><b>Change Log:</b> <a href="#" @click="viewChangeLogModal">View</a></p>

                    <div class="row mt-3 mb-2 px-3"><!--start of row button group-->
                      <div class="col-md-12 mt-3 ta-right p-0">
                        <b-button variant="primary" class="w-sm me-2" type="submit" :disabled="provider_id > 0 ? !eloadProviderModule.access.update : !eloadProviderModule.access.create">{{provider_id == 0 ? "Save":"Update"}}</b-button>
                        <b-button variant="light" class="w-sm ml-2" type="button" @click="cancelRouting" >Cancel</b-button>
                      </div>
                    </div><!--end of row button group-->

                    </form>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->


      <!-- Change log modal -->
      <b-modal
        id="changeLog"
        size="lg"
        centered
        hide-footer
        v-model="changeLogModal"
      >
        <template #modal-title>
          Change log: <span class="text-capitalize">{{form.provider_name}}</span>
        </template>
        <div class="row">
            <div class="w-auto mb-2">
              <div class="d-flex mt-3 mb-3">
                <div class="me-3 ta-right">
                  <b-form-group label-for="reward-status" description="Filter by date">
                    <flat-pickr
                      v-model="searchValue.dateRange"
                      :config="rangeOptions"
                      placeholder="Select a date range"
                      class="form-control"
                      style="width: fit-content"
                    ></flat-pickr>
                  </b-form-group>
                </div><!--filter by date-->
                <div class="me-3 ta-right">
                  <b-form-group label-for="reward-status" description="Filter by Type of Margin">
                    <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                      id="reward-status"
                      v-model="searchValue.margin_type"
                      :options="marginTypeOption"
                    ></b-form-select>
                  </b-form-group>
                </div><!--filter by type of margin-->
                <div class="me-3">
                  <b-button variant="primary" type="button" @click="getProviderLogs()" class="px-2 me-2">
                    <i class='bx bx-search bx-fw'></i>
                    Search
                  </b-button>
                </div><!--search button-->
              </div>
            </div><!--filter modal-->
            <div class="col-sm-12">
              <!-- table responsive -->
              <div class="table-responsive">
                <div class="table align-middle table-nowrap">
                  <b-table
                    :items="providerLogs"
                    :fields="logFields"
                    responsive="sm"
                    :current-page="searchValue.page"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    @sort-changed="tableSorting"
                  >
                    <template #cell(actor)="data">
                      <span :title="data.item.remarks">{{ data.item.actor}}</span>
                    </template>
                    <template #cell(margin_type)="data">
                      {{ data.item.margin_type == "fm"? "Front Margin":
                        (data.item.margin_type == "bm"? "Back Margin":"...") }}
                    </template>
                    <template #cell(created_at)="data">
                      <p class="text-body text-end m-0">
                        {{ data.item.created_at | formatDate }}
                      </p>
                    </template>
                    <template #cell(old_value)="data">
                      {{ data.item.old_value == data.item.new_value ? "":data.item.old_value}}
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="row g-0 text-center" v-if="providerLogsTotal == 0">
                <span>No data to display.</span>
              </div>
              <div class="row g-0 text-center text-sm-start">
                <!-- end col -->
                <div class="col-sm-12"  v-if="providerLogsTotal != 0 && providerLogsTotal > 10">
                  <div class="row">
                    <div class="col">
                      <div
                        class="
                          dataTables_paginate
                          paging_simple_numbers
                          float-end
                        "
                      >
                        <!-- pagination -->
                        <b-pagination  v-if="providerLogsTotal != 0 && providerLogsTotal > 6 && providerLogsTotal > searchValue.rows"
                          class="pagination-rounded"
                          v-model="searchValue.page"
                          @input="getProviderLogs"
                          :total-rows="providerLogsTotal"
                          :per-page="searchValue.rows"
                        ></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end col -->
              </div>
            </div><!--end of col-12-->
        </div><!--end of row-->
      </b-modal>
      <!-- end winner modal -->
  </div> <!-- end of outer div-->
</template>